import React from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/ThemeContext';
import Sidebar from './Sidebar';
import Header from './Header';

const Layout = () => {
  const { i18n } = useTranslation();
  const { sidebarCollapsed } = useTheme();
  
  const isRTL = i18n.language === 'ar';

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div
        className="min-h-screen flex flex-col transition-all duration-300"
        style={{
          marginLeft: isRTL ? '0' : (sidebarCollapsed ? '4rem' : '16rem'),
          marginRight: isRTL ? (sidebarCollapsed ? '4rem' : '16rem') : '0',
          width: `calc(100vw - ${sidebarCollapsed ? '4rem' : '16rem'})`
        }}
      >
        {/* Header */}
        <Header />

        {/* Page Content */}
        <main className="flex-1 overflow-auto">
          <div className="w-full max-w-none px-4 sm:px-6 lg:px-8 py-8" style={{ maxWidth: '100%', overflowX: 'hidden' }}>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
